import React, { useEffect } from "react";
import { useStoreState, useStoreActions } from "../../../store/hooks";
import WhatsNewModal from "./WhatsNewModal";

// Local storage key to track if the user has seen the modal
const WHATSNEW_SEEN_KEY = "gatherer_whatsnew_seen";

const WhatsNewModalContainer: React.FC = () => {
  const visible = useStoreState((state) => state.whatsNew.visible);
  const setVisible = useStoreActions((actions) => actions.whatsNew.setVisible);

  // Check if the user has seen the modal before
  useEffect(() => {
    const hasSeenWhatsNew = localStorage.getItem(WHATSNEW_SEEN_KEY);
    
    if (!hasSeenWhatsNew) {
      // Show the modal if user hasn't seen it
      setVisible(true);
      
      // Mark as seen for future visits
      localStorage.setItem(WHATSNEW_SEEN_KEY, "true");
    } else {
      // Don't show the modal if user has seen it
      setVisible(false);
    }
  }, [setVisible]);

  return visible ? <WhatsNewModal /> : null;
};

export default WhatsNewModalContainer; 